import $state from '~/plugins/uploader/download-state.js'

export default {
  name: 'file.downloadupdated',
  background (payload, {dispatch, state}, {sha, token, socket}) {
    const {task_id, progress} = payload
    if (task_id !== undefined) {
      $state.updateFileProgress(task_id, progress)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/notifications/notifications/FileDownloadUpdated.js